export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100" />

      <div className="absolute top-0 right-0 w-[600px] md:w-[800px] h-full opacity-[0.06] pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-500" />
        <div className="absolute top-40 right-40 w-[300px] h-[300px] rounded-full bg-accent-500" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1"></i>每日更新 · 片源不断
            </span>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] leading-tight text-foreground-950 tracking-tight">
              窝窝影院
              <span className="block text-primary-600 mt-2">
                高清流畅 · 免费观影
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-foreground-600 font-medium">
              海量高清影视，随时随地畅享极致观影体验
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-[620px] mx-auto lg:mx-0">
              窝窝影院汇聚全网最新电影、热门电视剧、经典纪录片与热门综艺，采用先进高清解码技术，实现即点即播零缓冲。超清画质搭配纯净无广告观影环境，每日同步更新热播内容，为您打造影院级家庭观影体验。无论追剧还是补番，窝窝影院都是您最值得信赖的免费在线观影平台。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-movie-line"></i>
                </div>
                <span>
                  <strong className="text-foreground-900">每日更新</strong> 100+ 部
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-4k-line"></i>
                </div>
                <span>
                  <strong className="text-foreground-900">全高清</strong> 超清画质
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-shield-check-line"></i>
                </div>
                <span>
                  <strong className="text-foreground-900">零广告</strong> 纯净观影
                </span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[520px]">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-gradient-to-br from-primary-100/60 via-accent-100/40 to-background-100/40 blur-xl" />
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20spotlight%20on%20dark%20stage%2C%20elegant%20movie%20theater%20atmosphere%20with%20velvet%20curtains%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20classic%20cinema%20aesthetic%2C%20rich%20warm%20tones%2C%20artistic%20composition%20with%20film%20strip%20elements%2C%20luxurious%20and%20inviting%20mood&width=1040&height=780&seq=hero-cinema-01&orientation=landscape"
                  alt="窝窝影院 - 沉浸式观影体验"
                  className="w-full h-auto object-cover aspect-[4/3]"
                  title="窝窝影院高清观影体验"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}